import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LocalStorageService } from '../services/local-storage.service';



@Injectable({
    providedIn: 'root'
})
export class DisplayBehaviorService {
    private local = inject(LocalStorageService);

    private currentDisplayBehavior: BehaviorSubject<E_DisplayBehavior> = new BehaviorSubject<E_DisplayBehavior>(E_DisplayBehavior.Default);

    constructor() {
        this.initializeDisplayBehavior();
    }

    private initializeDisplayBehavior() {
        const localValue = this.local.getItem("display-behavior");
        this.currentDisplayBehavior.next(localValue == E_DisplayBehavior.Demo ? E_DisplayBehavior.Demo : E_DisplayBehavior.Default);
    }

    getDisplayBehavior(): Observable<E_DisplayBehavior> {
        return this.currentDisplayBehavior.asObservable();
    }

    setDisplayBehavior(mode: E_DisplayBehavior): void {
        this.local.setItem("display-behavior", mode);
        this.currentDisplayBehavior.next(mode);
    }

}


export enum E_DisplayBehavior {
    Default = 'default',
    Demo = 'demo',
}